import {Component, EventEmitter, ChangeDetectionStrategy, NgZone, OnInit, Inject, LOCALE_ID} from '@angular/core';
import { Project } from '../../../models/project.model';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'project-item',
  templateUrl: './project-item.component.html',
  styleUrls: ['./project-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['project', 'index', 'selected'],
  outputs: ['projectSelected'],
})
export class ProjectItemComponent implements OnInit {
  project: Project = {};
  index: number = 0;

  selected: boolean = false;
  fxShowxs: boolean = false;
  fxShowsm: boolean = false;
  fxShowmd: boolean = false;

  projectSelected = new EventEmitter();

  constructor(private ngZone: NgZone,
              @Inject(LOCALE_ID) public locale: string
              ) {
  }

  ngOnInit(): void {

  }

  select() {
    this.projectSelected.emit(this.project.uuid);
  }
}
